<template lang="pug">
div
  sticky(className="sub-navbar")
    el-button(type='primary' size='mini' icon='el-icon-upload' @click='onSave')
      | 保存
    //- form(:action='getAPI(true) + "?lang=en"' method='post' target='_blank')
    //-   input(type='hidden' :value='getJsonFormData()' name='json')
    //-   el-button(type='warning' size='mini' icon='el-icon-view' native-type='submit') プレビュー[英語]
    //- form(:action='getAPI(true) + "?lang=ja"' method='post' target='_blank')
    //-   input(type='hidden' :value='getJsonFormData()' name='json')
    //-   el-button(type='warning' size='mini' icon='el-icon-view' native-type='submit') プレビュー[日本語]
  .contents-container
    el-form.c-form(ref='form', :model='form', v-loading='LOADING')
      header.c-form__header
        h1 必須項目
      .c-form__body(v-if='dataloaded')
        section.c-form__item
          header.c-form__item__header
            h1 メイン画像
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item
                  upload-single(:form='form' datakey='main_image' ratio='free')
        section.c-form__item
          header.c-form__item__header.--c
            h1 説明文
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.description.ja' placeholder='説明文を入力してください' type='textarea' :rows='15')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.description.en' placeholder='説明文を入力してください' type='textarea' :rows='15')
        section.c-form__item(v-for='(i, index) in OPTIONS.work_media_type')
          header.c-form__item__header
            h1 Mediums - {{i.name}}
            .func
              el-button(size='small' type='primary' icon='el-icon-plus' @click='addMedia(i.id)') 追加
              el-button(size='small' type='danger' icon='el-icon-delete' @click='delMedia(i.id)' :disabled='!form.mediums[index] || form.mediums[index].length < 1') 削除
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                draggable.c-list__works(v-model='form.mediums[index].works' element='ul' :name='`mediums_${index}`')
                  li(v-for='(i, index) in getMediaType(i.id)' :key='`mediums_${i.id}_${index}`')
                    template(v-if='getWorkDetailData(i).main_video.image')
                      img.c-thumb__item--s(:src='getWorkDetailData(i).main_video.image.uri')
                    template(v-else)
                      .c-thumb__item--s
                        p no image
                    | {{getWorkDetailData(i).title.ja}}

        section.c-form__item
          header.c-form__item__header
            h1 Leaders
            .func
              el-button(size='small' type='primary' icon='el-icon-plus' @click='addLeader()') 追加
              el-button(size='small' type='danger' icon='el-icon-delete' @click='delLeader()' :disabled='form.leaders.length < 1') 削除
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                draggable.c-list__works(v-model='form.leaders' element='ul' name='leaders')
                  li(v-for='(i, index) in form.leaders' :key='`leaders_${index}`')
                    template(v-if='getTalentDetail(i)')
                      img.c-thumb__item--1-1(:src='getTalentDetail(i).profile_image.uri')
                      span.u-margin__left--s {{getTalentDetail(i).name.ja}}
                    template(v-else)
                      .c-thumb__item--1-1
                        p no image
        section.c-form__item
          header.c-form__item__header
            h1 Awards (日英共通表示)
            .func
              el-button(size='small' type='primary' icon='el-icon-plus' @click='addText("awards")') 追加
              el-button(size='small' type='danger' icon='el-icon-delete' @click='delText("awards")' :disabled='form.awards.length < 1') 削除
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                draggable(v-model='form.awards' name='awards')
                  el-form-item(v-for='(i, index) in form.awards' :key='`awards_${index}`')
                    el-input(v-model='form.awards[index]' placeholder='Awardを入力してください ' )
        section.c-form__item
          header.c-form__item__header
            h1 Exhibitions (日英共通表示)
            .func
              el-button(size='small' type='primary' icon='el-icon-plus' @click='addText("exhibitions")') 追加
              el-button(size='small' type='danger' icon='el-icon-delete' @click='delText("exhibitions")' :disabled='form.exhibitions.length < 1') 削除
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                draggable(v-model='form.exhibitions' name='exhibitions')
                  el-form-item(v-for='(i, index) in form.exhibitions' :key='`exhibitions_${index}`')
                    el-input(v-model='form.exhibitions[index]' placeholder='Exhibitionsを入力してください ' )
  modal-add-talent-element(:visible='modalvisible.talent' @hideModal='hideTalentModal')
  modal-add-works-element(:visible='modalvisible.works' @hideModal='hideWorksModal' :media_type='media_type')
</template>

<script type='text/javascript'>
import Sticky from '@/components/Element/Sticky'
import UploadSingle from '@/components/Element/Upload/Single'
import form from '@/mixins/form'
import ModalAddTalentElement from '@/components/Element/Modal/AddTalentElement'
import ModalAddWorksElement from '@/components/Element/Modal/AddMediaWorksElement'
import draggable from 'vuedraggable'
export default {
  name: 'PagesStudioDetail',
  mixins: [form],
  data () {
    return {
      media_type: 1,
      modalvisible: {
        works: false,
        talent: false
      },
      form: {
        main_image: {
          id: null,
          uri: null
        },
        description: {
          ja: null,
          en: null
        },
        leaders: [],
        awards: [],
        exhibitions: [],
        mediums: []
      }
    }
  },
  methods: {
    addText (datakey) {
      this.form[datakey].push(null)
    },
    delText (datakey) {
      this.form[datakey].splice(this.form[datakey].length - 1, 1)
    },
    addMedia (id) {
      this.modalvisible.works = true
      this.media_type = id
    },
    delMedia (id) {
      const index = this.form.mediums.findIndex(item => item.media_type_id === id)
      console.log(index)
      console.log(this.form.mediums[index])
      this.form.mediums[index].works.pop()
    },
    addLeader () {
      this.modalvisible.talent = true
    },
    deleteLeader (index) {
      this.form.leaders.splice(index, 1)
    },
    hideTalentModal (data) {
      this.modalvisible.talent = false
      if (data.id) {
        this.form.leaders.push(data.id)
      }
    },
    hideWorksModal (data) {
      this.modalvisible.works = false
      if (data.id) {
        // this.form.mediums.push(data.id)
        // this.media_typeに該当する値が this.form.mediums の配列ないに存在するかチェック
        const index = this.form.mediums.findIndex(item => item.media_type_id === this.media_type)
        // 存在しない場合は新しい配列を作成
        if (index === -1) {
          this.form.mediums.push({
            media_type_id: this.media_type,
            works: [data.id]
          })
        } else {
          // 存在する場合はその配列に追加
          this.form.mediums[index].works.push(data.id)
        }
      }
    },
    // this.form.mediumsの配列からmedia_type_idに該当する値を持つ要素取得
    getMediaType (id) {
      const index = this.form.mediums.findIndex(item => item.media_type_id === id)
      if (index !== -1) {
        return this.form.mediums[index].works
      }
      return []
    },
    delLeader () {
      this.form.leaders.splice(this.form.leaders.length - 1, 1)
    }

  },
  created () {
    this.getWorkType()
    this.init()
  },
  components: {
    Sticky,
    UploadSingle,
    ModalAddTalentElement,
    ModalAddWorksElement,
    draggable
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Studio/index.vue